import { render, staticRenderFns } from "./detailTrainer.vue?vue&type=template&id=2bacb432&scoped=true"
import script from "./detailTrainer.vue?vue&type=script&lang=js"
export * from "./detailTrainer.vue?vue&type=script&lang=js"
import style0 from "./detailTrainer.vue?vue&type=style&index=0&id=2bacb432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bacb432",
  null
  
)

export default component.exports